import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Applicant from './Applicant/Applicant';
import { Flex, Grid } from '@zillow/constellation';
import { sectionMixin } from '../../../LandlordReviewPage/LandlordReview/Routes/ApplicantDetails/utils/viewMoreMixins';
import { getApplicantName } from '../ApplicationRollup.utils';
import { applicantStatusTypes } from '../../../../constants/statusConstants';

const StyledApplicant = styled(Applicant)`
  ${sectionMixin}
`;

export default function Applicants({ applicants = [], invitations = [], ...rest }) {
  return (
    <Flex {...rest} id="applicants-section">
      <Grid
        display="grid"
        rowGap="md"
        columnGap="lg"
        gridTemplateColumns={{
          default: '1fr',
          md: 'repeat(2, minmax(0, 1fr))',
          xl: 'repeat(3, minmax(0, 1fr))',
        }}
      >
        {applicants.map((applicant) => (
          <StyledApplicant
            status={applicant.status}
            name={getApplicantName(applicant)}
            submittedDateTime={applicant.submittedDateTime}
            scrollLinkKey={applicant.userId}
            isExpanded
            key={applicant.userId}
          />
        ))}
        {invitations.map((invitation) => (
          <StyledApplicant
            status={applicantStatusTypes.INVITED.id}
            name={[invitation.firstName, invitation.lastName].filter(Boolean).join(' ')}
            scrollLinkKey={invitation.email}
            isExpanded
            key={invitation.email}
          />
        ))}
      </Grid>
    </Flex>
  );
}

Applicants.propTypes = {
  applicants: PropTypes.arrayOf(
    PropTypes.shape({
      answers: PropTypes.shape({
        firstName: PropTypes.string,
        middleName: PropTypes.string,
        lastName: PropTypes.string,
      }),
      status: PropTypes.string,
      userId: PropTypes.string.isRequired,
    }),
  ),
  invitations: PropTypes.arrayOf(
    PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string,
    }),
  ),
};
